
import { defineComponent } from 'vue'
import AppointmentSchedule from '../components/appointments/AppointmentSchedule.vue'

export default defineComponent({
  name: 'AppointmentView',
  components: { AppointmentSchedule }
})
